<template>
  <b-modal
      :id="idModal"
      :ok-title="btnOkLabel"
      :cancel-title="btnCancelLabel"
      ok-variant="danger"
      :modal-class="moodalClass"
      :centered="centered"
      :title="title"
      @ok="$emit('ok')"
      @cancel="$emit('cancel')"
  >
    <b-card-text v-if="!$slots.message">
      {{ message }}
    </b-card-text>
    <slot v-if="$slots.message" name="message"></slot>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalConfirmation',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    btnOkLabel: {
      type: String,
      default: 'Ok, deletar',
    },
    btnCancelLabel: {
      type: String,
      default: 'Cancelar',
    },
    idModal: {
      type: String,
      default: 'modal-primary',
    },
    title: {
      type: String,
      default: 'Primary Modal',
    },
    message: {
      type: String,
      default: 'Tem certeza que deseja deletar?',
    },
    centered: {
      type: Boolean,
      default: true,
    },
    moodalClass: {
      type: String,
      default: '',
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showModal();
      } else {
        this.hideModal();
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    showModal() {
      this.$bvModal.show(this.idModal);
    },
    hideModal() {
      this.$bvModal.hide(this.idModal);
    },
  },
};
</script>

<style scoped lang="scss"></style>
